import React, { FC, MouseEventHandler, useState } from 'react';
import { Flex, Text, VStack, Box, Skeleton } from '@chakra-ui/react';
import { useModalDispatch, useScreenSizeState } from '@olo-web/client-state';
import { formatPrice } from '@olo-web/domain/orders/functions/formatPrice';
import { EModalTypes } from '@olo-web/types/enums';

type TItemUpsellCardProps = {
  item: IMenuItem;
};

export const ItemUpsellCard: FC<TItemUpsellCardProps> = ({ item }) => {
  const { isMdDown } = useScreenSizeState();
  const modalDispatch = useModalDispatch();
  const [mouseDownX, setMouseDownX] = useState(0);

  const openItemDetailsModal = () => {
    modalDispatch({
      type: 'OPEN_MODAL',
      payload: {
        modalKey: EModalTypes.ITEM_DETAILS,
        modalContext: {
          item,
          groupName: 'item_recommendations',
        },
      },
    });
  };

  const handleClick = () => {
    if (!isMdDown) return;
    openItemDetailsModal();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      openItemDetailsModal();
    }
  };

  const handleMouseDown: MouseEventHandler<Element> = (e) => {
    if (isMdDown) return;
    setMouseDownX(e.clientX);
  };

  const handleMouseUp: MouseEventHandler<Element> = (e) => {
    if (isMdDown) return;
    if (Math.abs(mouseDownX - e.clientX) < 20) {
      openItemDetailsModal();
    }
  };

  return (
    <Flex
      tabIndex={0}
      minH="64px"
      maxH="108px"
      w="100%"
      bg="white"
      borderRadius="md"
      align="center"
      justify="space-between"
      overflow="hidden"
      borderColor="blackAlpha.300"
      borderWidth="1px"
      _pressed={{ opacity: 0.7 }}
      _hover={{ boxShadow: 'md' }}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onKeyPress={handleKeyPress}
    >
      <VStack align="flex-start" p={2} justify="space-between" h="100%">
        <Text lineHeight="xs" textStyle="pBold" fontSize="14px" noOfLines={3}>
          {item?.name}
        </Text>
        <Text lineHeight="xs" textStyle="p" fontSize="12px">
          {formatPrice(item.price)}
        </Text>
      </VStack>
      {item.imageUrl && (
        <Box
          minW="136px"
          maxW="136px"
          h="100%"
          bgImg={item.imageUrl}
          bgPos="center"
          bgSize="cover"
        />
      )}
    </Flex>
  );
};

export const ItemUpsellCardSkeleton = () => (
  <Skeleton
    minH="64px"
    w="100%"
    bg="white"
    borderRadius="md"
    alignItems="center"
    justifyContent="space-between"
    overflow="hidden"
    borderColor="blackAlpha.300"
    borderWidth="1px"
  />
);
